/**
 * Lucid serializes DB snake_case columns as camelCase on the User model.
 * Legacy UI reads snake_case on state.user.user. When an endpoint returns only
 * camelCase (or omits mirrors), fill snake_case without clobbering explicit values.
 */
export function normalizeUserFromApi(user) {
  if (!user || typeof user !== "object") return user
  const u = { ...user }

  const pick = (snake, camel, fallback) => {
    if (u[snake] === undefined) {
      const c = u[camel]
      u[snake] = c !== undefined ? c : fallback
    }
  }

  pick("has_submitted_application", "hasSubmittedApplication", 0)
  pick("tier_confirmed", "tierConfirmed", 0)
  pick("has_completed_pre_survey", "hasCompletedPreSurvey", 0)
  pick("has_completed_post_survey", "hasCompletedPostSurvey", 0)
  pick("has_completed_application_guide", "hasCompletedApplicationGuide", 0)
  pick("is_spouse", "isSpouse", 0)
  if (u.privacy_policy === undefined) {
    u.privacy_policy =
      u.privacyPolicy !== undefined ? u.privacyPolicy : null
  }
  if (u.profile_image_url === undefined && u.profileImageUrl !== undefined) {
    u.profile_image_url = u.profileImageUrl
  }

  return u
}
